import { CATEGORIES } from "@/mocks/news";

export default function Channels() {
  return (
    <section id="channels" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            Channels
          </p>
          <h3 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
            爆料频道分类
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            不同领域的线索与话题，分门别类持续更新。选择你关注的频道，查看相关爆料与跟进进展。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CATEGORIES.map((cat) => (
            <a
              key={cat.id}
              href="#latest"
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={cat.image}
                  alt={`${cat.name}频道线索与资讯`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute right-3 top-3 rounded-sm bg-background-950/60 px-2 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  {cat.count} 条更新
                </span>
                <div className="absolute bottom-3 left-4">
                  <p className="text-sm font-medium text-background-50/70">{cat.en}</p>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <h4 className="font-heading text-lg font-bold text-foreground-950">
                    {cat.name}
                  </h4>
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 text-foreground-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-up-line"></i>
                  </span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {cat.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}